var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("There's nothing here!")]),_c('p',[_vm._v(" Sorry, um...yeah. ")]),_c('v-btn',{attrs:{"to":"/","color":"primary","outlined":""}},[_vm._v("Back to Favorites")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }